import Alert from 'components/Alert';
import { cleanAlert } from 'ducks/alerts';
import React from 'react';
import { connect } from 'react-redux';

const Component = props => {
  const { alert } = props;
  const { cleanAlert } = props;

  return (
    <Alert
      open={alert.message.length !== 0}
      message={alert.message}
      handleClose={cleanAlert}
      placement={{ vertical: 'bottom', horizontal: 'left' }}
      variant={'error'}
    />
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert
});

const mapDispatchToProps = dispatch => ({
  cleanAlert: () => dispatch(cleanAlert())
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
